import React from "react";
import ScrollToTop from "react-scroll-to-top";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { Security } from "@okta/okta-react";

import RoutesWrapper from "./routesWrapper";
import { oktaAuthConfig } from "modules/okta/oktaConfig";
import { CONSTANTS } from "utilities/constants";
import commonUtilities from "utilities/common";
import { CONFIGURATION } from "utilities/configuration";

const authorizationConfig = new OktaAuth(oktaAuthConfig);

const CustomIcon = () => (
    <svg id="Layer_1" data-name="Layer 1" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
        <path d="M53.11,96.59V12.19l38.18,38.19c.29.29.63.52,1.01.67.38.16.78.24,1.19.24.41,0,.81-.08,1.19-.24.38-.16.72-.39,1.01-.67.29-.29.52-.63.67-1.01.16-.38.24-.78.24-1.19,0-.41-.08-.81-.24-1.19-.16-.38-.38-.72-.67-1.01L50,.3,4.31,45.99c-.29.29-.52.63-.67,1.01-.16.38-.24.78-.24,1.19,0,.41.08.81.24,1.19.16.38.39.72.67,1.01.29.29.63.52,1.01.67.38.16.78.24,1.19.24.41,0,.81-.08,1.19-.24.38-.16.72-.39,1.01-.67L46.89,12.19v84.4c0,.82.33,1.61.91,2.2s1.37.91,2.2.91,1.61-.33,2.2-.91c.58-.58.91-1.37.91-2.2h0Z"/>
    </svg>
);

const App = () => {
    const restoreOriginalUri= async (_oktaAuth, originalUri) => {
        if(typeof window !== "undefined") {
            window.location.replace(toRelativeUrl(originalUri || "/", window.location.origin));
        }
    };

    return (
        <div className="row">
            <ScrollToTop smooth color="#FF6000"
                component={CONFIGURATION.APPLY_FIELD_ADORNMENT ? <CustomIcon /> : null}
            />
            <div className="container responsive">
                <Security oktaAuth={authorizationConfig} restoreOriginalUri={restoreOriginalUri}>
                    <RoutesWrapper />
                </Security>
            </div>
        </div>
    );
};

export default App;